import { render, staticRenderFns } from "./ComplianceProgram.vue?vue&type=template&id=5c0964e1&scoped=true"
import script from "./ComplianceProgram.vue?vue&type=script&lang=js"
export * from "./ComplianceProgram.vue?vue&type=script&lang=js"
import style0 from "./ComplianceProgram.vue?vue&type=style&index=0&id=5c0964e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0964e1",
  null
  
)

export default component.exports